module.exports = __webpack_public_path__ + "static/media/MiKLogo_en.5703a4e7.png";